/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EmailCode as BoServiceControllersEmailCode } from '../models/BoService/Controllers/email-code';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiEmailSendEmailCodeGet
   */
  static readonly ApiEmailSendEmailCodeGetPath = '/api/Email/SendEmailCode';

  /**
   * Sending a verification code by email.
   *
   * ### Claim
   *  boservice.email.sendemailcode
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmailSendEmailCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmailSendEmailCodeGet$Plain$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * Email
     */
    email?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BoServiceControllersEmailCode>> {

    const rb = new RequestBuilder(this.rootUrl, EmailService.ApiEmailSendEmailCodeGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.query('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BoServiceControllersEmailCode>;
      })
    );
  }

  /**
   * Sending a verification code by email.
   *
   * ### Claim
   *  boservice.email.sendemailcode
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmailSendEmailCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmailSendEmailCodeGet$Plain(params?: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * Email
     */
    email?: string;
  },
  context?: HttpContext

): Observable<BoServiceControllersEmailCode> {

    return this.apiEmailSendEmailCodeGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<BoServiceControllersEmailCode>) => r.body as BoServiceControllersEmailCode)
    );
  }

  /**
   * Sending a verification code by email.
   *
   * ### Claim
   *  boservice.email.sendemailcode
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmailSendEmailCodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmailSendEmailCodeGet$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * Email
     */
    email?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BoServiceControllersEmailCode>> {

    const rb = new RequestBuilder(this.rootUrl, EmailService.ApiEmailSendEmailCodeGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.query('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BoServiceControllersEmailCode>;
      })
    );
  }

  /**
   * Sending a verification code by email.
   *
   * ### Claim
   *  boservice.email.sendemailcode
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmailSendEmailCodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmailSendEmailCodeGet(params?: {

    /**
     * Interface language
     */
    lang?: string;

    /**
     * Email
     */
    email?: string;
  },
  context?: HttpContext

): Observable<BoServiceControllersEmailCode> {

    return this.apiEmailSendEmailCodeGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<BoServiceControllersEmailCode>) => r.body as BoServiceControllersEmailCode)
    );
  }

}
